var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1796_3478)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.085 0C9.45826 0 0 9.45826 0 21.085C0 32.7117 9.45826 42.17 21.085 42.17C32.7117 42.17 42.17 32.7117 42.17 21.085C42.17 9.45826 32.7117 0 21.085 0ZM28.8497 26.3649C29.5366 27.0522 29.5366 28.1624 28.8497 28.8497C28.507 29.1923 28.0572 29.3644 27.6071 29.3644C27.1574 29.3644 26.7076 29.1923 26.3649 28.8497L21.085 23.5694L15.8051 28.8497C15.4624 29.1923 15.0126 29.3644 14.5629 29.3644C14.1128 29.3644 13.663 29.1923 13.3203 28.8497C12.6334 28.1624 12.6334 27.0522 13.3203 26.3649L18.6006 21.085L13.3203 15.8051C12.6334 15.1178 12.6334 14.0075 13.3203 13.3203C14.0075 12.6334 15.1178 12.6334 15.8051 13.3203L21.085 18.6006L26.3649 13.3203C27.0522 12.6334 28.1624 12.6334 28.8497 13.3203C29.5366 14.0075 29.5366 15.1178 28.8497 15.8051L23.5694 21.085L28.8497 26.3649Z",
    fill: "#DFAF03"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1796_3478"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.17,
    height: 42.17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossicon);
export default __webpack_public_path__ + "static/media/crossicon.56a928d533b4e1ada8304eb910b3b37e.svg";
export { ForwardRef as ReactComponent };